import "./App.css";
import React from "react";
import { useState, useEffect } from "react";
import Question from "./components/Question/Question";
import StatusBar from "./components/StatusBar/StatusBar";
import DeadEnd from "./components/DeadEnd/DeadEnd";
import Layout from "./hoc/Layout/Layout";
import LoadingSpinner from "./components/LoadingSpinner/LoadingSpinner";
import Boilers from "./components/Boilers/Boilers";

function App() {
  const [state, setState] = useState({
    currentId: null,
    postCodeEntered: false,
    postCode: "",
    answers: [],
    result: null,
    questions: null,
    loading: false,
  });

  const fetchQuestions = async () => {
    setState({ ...state, loading: true });
    const res = await fetch(
      "https://europe-west2-sjw-plumbing.cloudfunctions.net/retrieveFormData"
    );
    const questions = await res.json();
    setState({
      ...state,
      loading: false,
      questions,
    });
  };

  useEffect(() => {
    fetchQuestions();
  }, []);

  useEffect(() => {});

  //submitting form once complete
  const submitForm = async (answers) => {
    try {
      setState({ ...state, loading: true });
      const res = await fetch(
        "https://europe-west2-sjw-plumbing.cloudfunctions.net/buildForm",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ answers }),
        }
      );
      const data = await res.json();
      setState({ ...state, result: data, loading: false });
    } catch (err) {
      setState({ ...state, loading: false });
      console.log(err);
    }
  };

  //updating state when an answer is selected
  const updateState = (question, answer, answerId, linksTo) => {
    const newState = {
      ...state,
      answers: [
        ...state.answers,
        {
          questionId: state.currentId,
          question,
          answer,
          answerId,
        },
      ],
      currentId: linksTo,
    };
    if (linksTo === null) {
      submitForm(newState.answers);
    } else {
      setState(newState);
    }
  };

  //revert to previous state
  const goBack = () => {
    setState({
      ...state,
      currentId: state.answers.length
        ? state.answers[state.answers.length - 1].questionId
        : null,
      postCodeEntered: state.answers.length ? true : false,
      answers: state.answers.slice(0, -1),
    });
  };

  const backToStart = () => {
    setState({
      ...state,
      currentId: 1,
      answers: [],
    });
  };

  if (state.loading) {
    //loading
    return (
      <div className="app">
        <LoadingSpinner />
      </div>
    );
  } else if (!state.postCodeEntered) {
    //postcode screen
    return (
      <Layout>
        {state.questions && (
          <React.Fragment>
            <Question
              question={{
                question: "Where do you live?",
                highlightedWord: "live",
              }}
              postCode={state.postCode}
              updateState={(postCode) => {
                return setState({
                  ...state,
                  currentId: 1,
                  postCodeEntered: true,
                  postCode,
                });
              }}
              goBack={goBack}
            />
            <StatusBar
              progress={state.answers.length}
              total={Object.keys(state.questions).length}
            />
          </React.Fragment>
        )}
      </Layout>
    );
  } else if (state.result) {
    //results
    return (
      <Layout>
        <Boilers
          boilers={state.result.filteredBoilers}
          goBack={goBack}
          backToStart={backToStart}
        />
      </Layout>
    );
  } else if (state.currentId === 0) {
    return (
      //dead end
      //do something...
      <Layout goBack={goBack}>
        <DeadEnd
          heading="No available options"
          subText="We cannot provide Combi boilers for houses with 3 or more showers. If you have any questions, please give us a ring on 01344 483816."
          backToStart={backToStart}
        />
      </Layout>
    );
  }
  //questions
  return (
    <Layout goBack={goBack}>
      {state.questions && (
        <React.Fragment>
          <Question
            question={state.questions[state.currentId]}
            updateState={updateState}
            goBack={goBack}
          />
          <StatusBar
            progress={state.answers.length}
            total={Object.keys(state.questions).length}
            goBack={goBack}
          />
        </React.Fragment>
      )}
    </Layout>
  );
}

export default App;
